<template>
  <div
    :class="cn(
      'tw:flex tw:*:not-first:not-last:rounded-none tw:*:not-only:last:rounded-l-none tw:*:not-only:first:rounded-r-none tw:[&>button,a]:shrink-0 tw:[&>button,a]:z-0 tw:[&>input,select]:z-10',
    )"
  >
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils.js'

defineOptions({
  name: 'InputGroup',
})
</script>
